import { $$ } from 'utils/dom';

const popupButtons = $$('.landingpage-popup__button');

if (popupButtons.length) {
  const toggleModal = button => {
    button.classList.toggle('is-active');
    button.nextElementSibling.classList.toggle('is-active');
  };

  popupButtons.forEach(popupButton => {
    popupButton.addEventListener('click', event => {
      toggleModal(popupButton);
    });
  });
}
